import React from "react";
import { Trash, PencilSquare } from "react-bootstrap-icons";
import { swalConfirmationAlert } from "../components/common/Alerts";

const Cart = ({
  extraCheese = false,
  extra_cheese_price = 0,
  base_price = 0,
  sizeShortDesc = "",
  selectedCheeses = [],
  selectedToppings = [],
  selectedFriesAddons = [],
  quantity = 1,
  onDelete,
  onEdit,
  itemIndex,
}) => {
  const handleDelete = () => {
    swalConfirmationAlert("¿Desea eliminar el pedido?", "", onDelete);
  };

  const handleEdit = () => {
    if (onEdit) {
      onEdit(itemIndex);
    }
  };

  const totalPedido =
    (Number(base_price) + (extraCheese ? Number(extra_cheese_price) : 0)) *
    Number(quantity);
  return (
    <div className="cart text-white pt-5">
      {/* Botones de acción arriba de todo */}
      <div className="d-flex justify-content-end gap-2 mb-3">
        <button
          onClick={handleEdit}
          className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
          aria-label="Editar pedido"
          style={{
            borderRadius: '8px',
            padding: '8px 12px',
            fontSize: '0.9rem',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            border: '2px solid #007bff',
            color: '#007bff',
            backgroundColor: 'transparent'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#007bff';
            e.target.style.color = 'white';
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 4px 8px rgba(0,123,255,0.3)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.color = '#007bff';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }}
        >
          <PencilSquare size={16} />
          Editar
        </button>
        
        <button
          onClick={handleDelete}
          className="btn btn-sm btn-outline-danger d-flex align-items-center gap-1"
          aria-label="Eliminar pedido"
          style={{
            borderRadius: '8px',
            padding: '8px 12px',
            fontSize: '0.9rem',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            border: '2px solid #dc3545',
            color: '#dc3545',
            backgroundColor: 'transparent'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#dc3545';
            e.target.style.color = 'white';
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 4px 8px rgba(220,53,69,0.3)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.color = '#dc3545';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }}
        >
          <Trash size={16} />
          Eliminar
        </button>
      </div>
      
      <div className="d-grid position-relative">
        <div className="card w-50 mx-auto text-center border-0 rounded-3 bg-red p-3 text-white mb-2 position-relative">
          <h2>
            <strong>{sizeShortDesc}</strong>
          </h2>
          <p>
            <span>Billy Talle {sizeShortDesc}</span>
          </p>
        </div>
        <div className="w-100 card mx-auto text-center border-0 rounded-3 bg-cream p-2 text-black mb-2">
          <p className="text-start">
            <strong>Quesos:</strong>{" "}
            {selectedCheeses.length > 0 ? (
              selectedCheeses.map((cheese) => (
                <span key={cheese.id}>{cheese.cheese_description} | </span>
              ))
            ) : (
              <span>Sin quesos agregados</span>
            )}
          </p>
          <p className="text-start">
            <strong>Toppings: </strong>{" "}
            {selectedToppings.length > 0 ? (
              selectedToppings.map((topping) => (
                <span key={topping.topping_id}>{topping.topping_name} | </span>
              ))
            ) : (
              <span>Sin toppings agregados</span>
            )}
          </p>
          <p className="text-start">
            <strong>Extra Queso?:</strong>{" "}
            {extraCheese ? (
              <>
                Sí <span className="text-success">(${extra_cheese_price})</span>
              </>
            ) : (
              "No"
            )}
          </p>
          <p className="text-end fs-5 d-grid mt-2">
            <strong>
              {quantity} x ${totalPedido}
            </strong>
            <span className="mt-1 font-size-15">
              Precio unitario: ${base_price}
            </span>
          </p>
        </div>
      </div>

      <div className="text-black">
        <h3>Papas:</h3>
        {selectedFriesAddons && selectedFriesAddons.length > 0 && (
          <div>
            <strong>Acompañamientos:</strong>
            <ul>
              {selectedFriesAddons.map((addon) => (
                <li key={addon.id}>
                  {addon.addon_name}{" "}
                  {addon.extra_price > 0 && `(+$${addon.extra_price})`}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      {/* <h6 className="text-end text-danger">Total: <strong>${quantity * base_price}</strong></h6> */}
    </div>
  );
};

export default Cart;
